<template>
  <div class="main-view">
    <el-card class="searchCard" shadow="never">
      <!-- 筛选 -->
      <el-form inline class="inline-form">
        <el-form-item label="创建时间">
          <date-range-picker v-model="createTime" :value="createTime" @getChange="dateChange"></date-range-picker>
        </el-form-item>
        <el-form-item label="商户编号">
          <el-input class="search-input" v-model="searchInfo.targetMerchantId" placeholder="请输入商户编号" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <auth-button opt="search" :plain="true" icon="el-icon-search" @click.native="searchClick" label="查询" :loading="loading"></auth-button>
          <auth-button opt="export" :plain="true" @click.native="exportClick" label="导出" :loading="exportLoading"></auth-button>
          <auth-button opt="pay" @click.native="payDialogVisible = true" label="发起付款"></auth-button>
          <auth-button opt="batch_pay" @click.native="batchPayDialogVisible = true" label="批量付款"></auth-button>
        </el-form-item>
      </el-form>
    </el-card>
    <!-- table -->
    <el-card class="tableCard" shadow="never">
      <el-col class="amount">
          <span class="label">可付款金额：</span>{{totalCanSubAmount}}
          <span class="label">总付款金额：</span>{{totalAmount}}
      </el-col>
      <el-table
        stripe
        style="width:100%;"
        :data="list"
        v-loading="loading"
        :header-cell-style="{background:'#FAFAFA'}">
        <el-table-column
          prop="createTimeStr"
          label="创建时间"
          align="center"
          min-width="200">
        </el-table-column>
        <el-table-column
          prop="targetMerchantId"
          label="收款方编号(商户编号)"
          align="center"
          min-width="200">
        </el-table-column>
        <el-table-column
          prop="merchantShortName"
          label="商户名称"
          align="center"
          min-width="200">
        </el-table-column>
        <el-table-column
          prop="accountName"
          label="开户名"
          align="center"
          min-width="150">
        </el-table-column>
        <el-table-column
          prop="bankCardNo"
          label="银行账号"
          align="center"
          min-width="150">
        </el-table-column>
        <el-table-column
          prop="bankBranchName"
          label="开户行"
          align="center"
          min-width="150">
        </el-table-column>
        <el-table-column
          prop="amount"
          label="付款金额"
          align="center"
          min-width="150">
          <template slot-scope="scope">
            {{(scope.row.amount / 100).toFixed(2)}}
          </template>
        </el-table-column>
        <el-table-column
          prop="statuStr"
          label="付款状态"
          align="center"
          min-width="150">
          <template slot-scope="scope">
            {{filterStatus(scope.row.statuStr)}}
          </template>
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          align="center"
          min-width="150">
          <template slot-scope="scope">
            {{scope.row.remark ? scope.row.remark : '-'}}
          </template>
        </el-table-column>
        <el-table-column
          prop="action"
          label="操作"
          align="center"
          min-width="150">
          <template slot-scope="scope">
            <auth-button opt="cancel" type="text" v-if="canCancel(scope.row.statuStr, scope.row.createTimeStr)" @click.native="cancelSubAccount(scope.row)" label="撤销付款"></auth-button>
            <span v-else>-</span>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <pagination @changePage="onChangeCurrentPage" :count="paginations.count" :page-no="paginations.pageNo"></pagination>
    <el-dialog
      v-if="payDialogVisible"
      title="发起付款"
      :visible.sync="payDialogVisible"
      size="small"
      width="600px"
      :close-on-click-modal="false">
      <el-form :model="payInfo" :rules="formRules" ref="payForm" label-width="100px">
        <el-form-item label="收款方" prop="targetMerchantId">
          <el-select
              style="width: 80%"
            :value="payInfo.targetMerchantId"
            v-model="payInfo.targetMerchantId"
            placeholder="请选择收款方"
            :loading="selectLoading"
            v-loadmore="loadMore"
            @change="getSelected">
            <el-option
              v-for="item in selectList"
              :key="item.merchantId"
              :label="item.merchantName"
              :value="item.merchantId">
            </el-option>
            <p v-if="noMore" class="noMore">暂无更多</p>
          </el-select>
        </el-form-item>
        <el-form-item label="付款金额" prop="totalAmount">
          <el-input placeholder="请输入付款金额" auto-complete="off" style="width: 80%" v-model="payInfo.totalAmount"><template slot="append">元</template></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" placeholder="请输入备注信息" auto-complete="off" style="width: 80%" v-model="payInfo.remark" :autosize="{ minRows: 2, maxRows: 4}" resize="none"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="payDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="createSubAccount" :loading="payLoading">确认</el-button>
      </span>
    </el-dialog>
    <el-dialog
      v-if="batchPayDialogVisible"
      title="批量付款"
      :visible.sync="batchPayDialogVisible"
      size="small"
      width="500px"
      @close="clearBatchInfo"
      :close-on-click-modal="false">
      <div class="tips">导入须知：请下载批量付款模板，并将收款方及付款金额按要求填入，每次导入不超过50个</div>
      <el-form class="batchPayForm">
        <el-form-item>
          <div>
            <input type="file" id="file" @change="getFile($event)" style="display:none" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"/>
            <el-button type="primary" size="small" class="check" @click="getMultiFiles()">批量导入</el-button>
            <a href="static/批量导入付款模板.xlsx" download>
              <span class="file-download-button">下载模板文件</span>
            </a>
            <p>仅支持.xls、.xlsx格式</p>
            <el-col v-if="multiFileName !== ''" class="hasSelect">
              <span>已选择: {{multiFileName}}</span>
              <i class="el-icon-remove removeIcon" @click="removeFile"></i>
            </el-col>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="clearBatchInfo">取消</el-button>
        <el-button type="primary" @click="batchPay" :loading="batchPayLoading">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import qs from 'qs'
import dateRangePicker from '@/components/dateRangePicker'
import pagination from '@/components/pagination'
import { pageSubAccount, createBatchSubAccount, exportSubAccount, cancelSubAccount, createSubAccount, pageBind } from '@/api/subAccount.js'
export default {
  name: 'PaymentRecord',
  components: {
    dateRangePicker,
    pagination
  },
  data () {
    return {
      loading: false,
      // 需要给分页组件传的信息
      paginations: {
        pageNo: 1,
        count: 0,
        pageSize: 20
      },
      // 搜索表单信息
      searchInfo: {
        startTime: '',
        endTime: '',
        targetMerchantId: ''
      },
      createTime: [],
      list: [],
      totalCanSubAmount: '--',
      totalAmount: '--',
      statusList: [
        { label: '付款中', value: 0 },
        { label: '付款成功', value: 1 },
        { label: '付款失败', value: 2 },
        { label: '付款撤销中', value: 3 },
        { label: '付款撤销成功', value: 4 },
        { label: '付款撤销失败', value: 5 }
      ],
      payDialogVisible: false,
      batchPayDialogVisible: false,
      exportLoading: false,
      multiFile: '',
      multiFileName: '',
      batchPayLoading: false,
      payInfo: {
        targetMerchantId: '',
        remark: '',
        totalAmount: ''
      },
      payLoading: false,
      formRules: {
        targetMerchantId: [{
          required: true,
          message: '请选择收款方',
          trigger: 'change'
        }],
        totalAmount: [{
          validator: (rule, value, callback) => {
            if (!value) {
              callback(new Error('请输入收款金额'))
            } else if (!/^([0-9]|[1-9]\d+)(\.\d{1,2})?$/.test(value)) {
              callback(new Error('请输入最多两位小数收款金额'))
            } else {
              callback()
            }
          },
          required: true,
          trigger: 'change'
        }],
        remark: [{
          validator: (rule, value, callback) => {
            if (!value) {
              callback()
            } else if (value.replace(/[\u4E00-\u9FA5]/g, '01').length > 20) {
              callback(new Error('备注不能超过20个字符'))
            } else {
              callback()
            }
          },
          trigger: 'change'
        }]
      },
      selectList: [{
        merchantId: this.$store.getters.userId,
        merchantName: this.$store.getters.userInfo.userEntity.fMerchantName
      }],
      noMore: false,
      selectPaginations: {
        pageNumber: 1,
        totalCount: 1,
        pageSize: 10
      }
    }
  },
  mounted () {
    this.getDefaultData()
    this.getSearchList()
  },
  methods: {
    /**
     * @description 初始加载数据方法
     */
    getDefaultData () {
      this.searchClick()
    },
    /**
     * @description 改变当前页事件
     * @param  {number} page 当前页码
     */
    onChangeCurrentPage (page) {
      this.paginations.pageNo = page
      this.searchClick()
    },
    /**
     * @description 筛选查询按钮点击
     */
    searchClick () {
      this.loading = true
      this.searchInfo.startTime = this.createTime && this.createTime[0] ? this.createTime[0] : ''
      this.searchInfo.endTime = this.createTime && this.createTime[1] ? this.createTime[1] : ''
      const params = qs.stringify(Object.assign({}, this.searchInfo, this.paginations))
      pageSubAccount(params).then(response => {
        this.loading = false
        if (response.error_code === '0') {
          this.list = response.data.list
          this.paginations.count = response.data.totalCount
          this.totalAmount = (response.data.totalAmount / 100).toFixed(2)
          this.totalCanSubAmount = (response.data.totalCanSubAmount / 100).toFixed(2)
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error',
            showClose: true
          })
        }
      })
    },
    dateChange (value) {
      this.createTime = value
    },
    filterStatus (status) {
      const result = this.statusList.filter(item => item.value === parseInt(status))
      if (result.length >= 1) {
        return result[0].label
      } else {
        return '未知'
      }
    },
    exportClick () {
      this.exportLoading = true
      this.searchInfo.startTime = this.createTime && this.createTime[0] ? this.createTime[0] : ''
      this.searchInfo.endTime = this.createTime && this.createTime[1] ? this.createTime[1] : ''
      const params = qs.stringify(Object.assign({}, this.searchInfo, {
        moduleCode: 11,
        moduleName: '乐云付',
        menuName: '付款明细'
      }))
      exportSubAccount(params).then(response => {
        this.exportLoading = false
        if (parseInt(response.result_cde) === 0) {
          this.$message({
            message: '导出成功，请大约1min后在下载中心中查看并下载',
            type: 'success',
            showClose: true
          })
        } else {
          this.$message({
            message: response.result_msg,
            type: 'error',
            showClose: true
          })
        }
      })
    },
    batchPay () {
      const data = new FormData()
      data.append('file', this.multiFile)
      this.batchPayLoading = true
      createBatchSubAccount(data).then((res) => {
        this.batchPayLoading = false
        if (res.error_code === '0') {
          console.log(res)
          this.$message({
            message: '批量付款成功',
            type: 'success',
            showClose: true
          })
          this.batchPayDialogVisible = false
        } else {
          this.$message({
            message: res.error_msg,
            type: 'error',
            showClose: true
          })
        }
      })
    },
    getMultiFiles () {
      this.$jquery('#file').click()
    },
    /**
       * @description 选择文件
       */
    getFile (event) {
      const name = event.target.files[0].name.split('.')
      if (!['xls', 'xlsx'].includes(name[name.length - 1])) {
        this.$message({
          message: '请上传.xls/.xlsx格式的文件！',
          type: 'warning',
          showClose: true
        })
        return
      }
      this.multiFile = event.target.files[0]
      this.multiFileName = this.multiFile.name
      event.target.value = null
    },
    /**
       * @description 删除已上传文件
       */
    removeFile () {
      this.$confirm('是否确认删除文件？', '提示', {}).then(() => {
        this.multiFile = ''
        this.multiFileName = ''
      })
    },
    cancelSubAccount (row) {
      const params = qs.stringify({
        thirdId: row.thirdId
      })
      cancelSubAccount(params).then(res => {
        if (res.error_code === '0') {
          this.$message({
            message: '撤销成功',
            type: 'success',
            showClose: true
          })
          this.searchClick()
        } else {
          this.$message({
            message: res.error_msg,
            type: 'error',
            showClose: true
          })
        }
      })
    },
    createSubAccount () {
      this.$refs.payForm.validate((valid) => {
        if (valid) {
          this.payLoading = true
          const payItem = JSON.parse(JSON.stringify(this.payInfo))
          payItem.totalAmount = payItem.totalAmount * 100
          const params = qs.stringify(payItem)
          createSubAccount(params).then(res => {
            this.payLoading = false
            console.log(res)
            if (res.error_code === '0') {
              this.$message({
                message: '付款成功',
                type: 'success',
                showClose: true
              })
              this.payDialogVisible = false
              this.searchClick()
            } else {
              this.$message({
                message: res.error_msg,
                type: 'error',
                showClose: true
              })
            }
          })
        }
      })
    },
    /**
             * 获取代理商下所有商户列表
             */
    getSearchList () {
      this.selectLoading = true
      const that = this
      const params = qs.stringify(this.selectPaginations)
      pageBind(params).then(response => {
        that.selectLoading = false
        if (parseInt(response.error_code) === 0) {
          this.selectList = this.selectList.concat(response.data.list)
          this.selectPaginations.totalCount = response.data.total
        } else {
          this.selectLoading = false
          this.$message({
            message: response.error_msg,
            type: 'error',
            showClose: true
          })
        }
      }).catch(() => {
        this.selectLoading = false
      })
    },
    loadMore () {
      if (!this.noMore && this.selectPaginations.pageNumber < Math.ceil((this.selectPaginations.totalCount - 1) / this.selectPaginations.pageSize)) {
        this.noMore = false
        this.selectPaginations.pageNumber++
        this.getSearchList()
      } else {
        this.noMore = true
      }
    },
    canCancel (status, createTime) {
      console.log(status)
      console.log(typeof status)
      status = parseInt(status)
      if (status === 0) {
        return true
      }
      return new Date().toLocaleDateString() === new Date(createTime).toLocaleDateString() && ![3, 4, 5].includes(status)
    },
    clearBatchInfo () {
      this.batchPayDialogVisible = false
      this.multiFile = null
      this.multiFileName = ''
      this.batchPayLoading = false
    }
  }
}
</script>

<style scoped lang="scss">
.main-view {
  padding-left: 16px;
}
.search-input {
  width: 160px;
}
.amount {
  height: 40px;
  line-height: 40px;
  .label {
    padding-left: 20px;
    color: #000;
    &:last-of-type {
      padding-left: 40px;
    }
  }
}
.file-download-button {
  color: #409eff;
  cursor:pointer;
  margin-left: 10px;
}
.batchPayForm {
  margin-top: 24px;
}
/deep/ .el-dialog__footer{
  text-align: center;
}
.noMore{
  font-size: 14px;
  color: #777;
  text-align: center;
  margin: 5px;
}
.hasSelect .removeIcon{
    color:#F56C6C;
    line-height: 30px;
    cursor: pointer;
    margin-left: 10px;
}
</style>
